module.exports = __webpack_public_path__ + "static/media/eitaa.2be847b7.svg";